import { hideContentVersion } from './delete'
import { readContentVersions } from './read'
import { updateContentVersionLabel } from './update'

export * from './types'

export const contentVersions = {
  readCollection: readContentVersions,
  updateLabel: updateContentVersionLabel,
  hide: hideContentVersion,
}
